import React from 'react';

var Media = props => {
  const { media } = props;

  if (media.kind === 'video') {
    return (
      <div className="vid">
        <div className="vid__wrap" id={`track-${media.id}`}></div>
      </div>
    )
  } else {
    return (
      <div id={`track-${media.id}`}></div>
    )
  }
};

export default Media;


// WEBPACK FOOTER //
// ./src/app/components/VTC/Media.js